import React, { memo, useCallback } from 'react';
import Icon from './Icon';

const AddTriggerButton = memo(({ hasNodes, onAddTrigger }) => {
  const handleClick = useCallback((event) => {
    event.stopPropagation();
    onAddTrigger();
  }, [onAddTrigger]);

  if (hasNodes) {
    // Modern floating button for populated canvas
    return (
      <div 
        className="add-trigger-floating"
        onClick={handleClick}
        title="Add new trigger"
      >
        <div className="add-trigger-floating-content">
          <Icon name="plus" size={18} />
          <span className="add-trigger-floating-text">Add Trigger</span>
        </div>
      </div>
    );
  }

  // Node-styled button for empty canvas
  return (
    <div 
      className="add-trigger-node"
      onClick={handleClick}
    >
      <div className="node-tag trigger">
        <Icon name="play" size={12} />
        Trigger
      </div>
      <div className="node-content">
        <div className="node-icon">
          <Icon name="plus" size={24} />
        </div>
        <div className="node-body">
          <p className="node-title">Add first step</p>
          <p className="node-description">Click to create your first trigger</p>
        </div>
      </div>
    </div>
  );
});

export default AddTriggerButton;